import { multiStep } from 'components/Wizards/MultiStepWizard/multiStep'
import Styles from './PostType.module.scss'
import { Formik } from 'formik'
import { Form } from 'components/Wizards/Form/Form'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Button } from 'blaze-ui/Button'
import { ArrowRight } from 'blaze-ui/icons'
import { StepProps } from 'components/Wizards/MultiStepWizard/Types'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import { useEffect } from 'react'
import { PostTypes } from '../../FlowC/FlowC'

interface Props {
  selectedType: string
  setSelectedType: (value: PostTypes) => void
  onMount: () => void
}

const PostType = multiStep<StepProps & Props>((props) => {
  const { schema, initialValues, onSubmit, selectedType, setSelectedType, onMount } = props
  const { submitLabel, header } = schema.describe().meta

  useEffect(() => onMount(), []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSubmit}
      initialValues={schema.cast({ ...schema.getDefault(), ...initialValues }, { assert: false })}
      enableReinitialize
    >
      {({ submitForm, isSubmitting }) => {
        return (
          <Form.Root>
            <Form.Section>
              <Form.SectionContent>
                <Form.Fields className={Styles.formFields}>
                  <div className={Styles.stepTitle}>
                    <Heading level={1}>{header}</Heading>
                  </div>
                  <div className={Styles.postOptions}>
                    <div
                      className={cx(Styles.postOption, { [Styles.selected]: selectedType === 'text' })}
                      onClick={() => setSelectedType('text')}
                    >
                      <div className={Styles.text}>
                        <Heading level={4}>Mostly text</Heading>
                        <Text color="var(--dark-60)">with a simple photo or video</Text>
                      </div>
                      <img
                        className={Styles.img}
                        alt="mostly text"
                        src="https://res.cloudinary.com/almanac/image/upload/v1743173629/blaze_assets/create_new_v3/MostlyText_gbgkyt.png"
                      />
                    </div>
                    <div
                      className={cx(Styles.postOption, { [Styles.selected]: selectedType === 'visual' })}
                      onClick={() => setSelectedType('visual')}
                    >
                      <div className={Styles.text}>
                        <Heading level={4}>More visual</Heading>
                        <Text color="var(--dark-60)">with a custom designed template</Text>
                      </div>
                      <img
                        className={Styles.img}
                        alt="more visual"
                        src="https://res.cloudinary.com/almanac/image/upload/v1743173629/blaze_assets/create_new_v3/MostlyVisual_di728e.png"
                      />
                    </div>
                  </div>
                </Form.Fields>
              </Form.SectionContent>
            </Form.Section>

            <Form.Actions isSticky>
              <Form.PrimaryActions>
                <Button
                  size="lg"
                  onPress={submitForm}
                  endIcon={ArrowRight}
                  isDisabled={isSubmitting}
                  aria-label={submitLabel}
                >
                  {submitLabel}
                </Button>
              </Form.PrimaryActions>
            </Form.Actions>
          </Form.Root>
        )
      }}
    </Formik>
  )
})

export { PostType }
